// extracted by mini-css-extract-plugin
export var modal = "_g5-0";